import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { colors } from '../utils';
import Chevron from '../assets/images/chevron-blue.svg';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  height: 380px;
  width: 100%;
`;

const Navigation = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  height: 80px;
  justify-content: space-between;
  width: 100%;
`;

const LinkButton = styled.button.attrs({
  type: 'button'
})`
  align-items: center;
  background-color: transparent;
  border: 0 none;
  display: flex;
  flex-direction: row;
  &:focus {
    outline: none;
  }
`;

const LinkText = styled.span`
  color: ${colors.b01};
  font-family: Mada;
  font-size: 16px;
  font-weight: bold;
`;

const ChevronIconBack = styled.img`
  height: 40px;
  width: 40px;
  transform: rotate(180deg);
`;

const ChevronIconNext = styled.img`
  height: 40px;
  width: 40px;
`;

const DotWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  justify-content: center;
`;

const DotCircle = styled.div`
  background-color: ${props => (props.active ? colors.g03 : 'transparent')};
  border: 1px solid ${colors.g03};
  border-radius: 100%;
  height: 12px;
  margin-right: 12px;
  width: 12px;

  &:last-child {
    margin-right: 0;
  }
`;

const Col = styled.div`
  align-items: center;
  display: flex;
  flex: 1;
  justify-content: center;

  &:first-child {
    justify-content: flex-start;
  }

  &:last-child {
    justify-content: flex-end;
  }
`;

function renderPrevButton(step, onStepChange) {
  if (step === 0) {
    return null;
  }

  return (
    <LinkButton type="button" onClick={() => onStepChange(step - 1)}>
      <ChevronIconBack src={Chevron} />

      <LinkText>Back</LinkText>
    </LinkButton>
  );
}

function renderNextButton(step, onStepChange, stepCount) {
  if (step === stepCount - 1) {
    return null;
  }

  return (
    <LinkButton type="button" onClick={() => onStepChange(step + 1)}>
      <LinkText>Next</LinkText>

      <ChevronIconNext src={Chevron} />
    </LinkButton>
  );
}

function renderCircles(arr, step) {
  const circles = [];

  for (let index = 0; index < arr.length; index += 1) {
    circles.push(<DotCircle active={index === step} key={`circles-${index}`} />);
  }

  return circles;
}

function Carousel({ step, onStepChange, children }) {
  const childrenArray = React.Children.toArray(children);

  return (
    <Container>
      <Content>{childrenArray[step]}</Content>

      <Navigation>
        <Col>{renderPrevButton(step, onStepChange)}</Col>

        <Col>
          <DotWrapper>{renderCircles(childrenArray, step)}</DotWrapper>
        </Col>

        <Col>{renderNextButton(step, onStepChange, childrenArray.length)}</Col>
      </Navigation>
    </Container>
  );
}

Carousel.propTypes = {
  step: PropTypes.number.isRequired,
  onStepChange: PropTypes.func.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.arrayOf(PropTypes.node)
  ]).isRequired
};

Carousel.Pane = ({ children }) => children;

export { Carousel };
